import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n";
import router from "@/lib/router";
import menu from "@/lib/menu";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.help.formulas": "Aide à l'écriture des formules"
		});

		breadcrumb.add([
			{
				path: "/help/formulas",
				name: "database>help.formulas"
			}
		]);

		router.addRoutes([
			{
				name: "help.formulas",
				path: "/help/formulas",
				component: () => import("./vues/HelpFormulasView.vue"),
				props: true,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			}
		]);

		menu.addEntry({
			label: i18n.t("breadcrumb.help.formulas") as string,
			icon: "fa fa-circle-question",
			location: { name: "help.formulas" },
			order: 999
		});
	}
};
